import axios from 'axios';
import { decodeToken } from 'react-jwt';
import config from '../config';

export function logActivity(msg) {
  const adminInfo = decodeToken(localStorage.getItem('token'));
  const logData = new FormData();
  logData.append('auth', localStorage.getItem('token'));
  logData.append('activity', msg);
  logData.append('user', adminInfo?.admin_id);

  axios.post(config.LOG_API, logData);
  // if (process.env.NODE_ENV !== 'development')
  //   axios.post(config.LOG_API, logData);
  // else console.log('Dev Logs: ' + msg);
}
